import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_general_camera_solid",
  "use": "icon-icon_general_camera_solid-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-icon_general_camera_solid\">\n<g>\n\t<g>\n\t\t<rect x=\"10\" y=\"15.9\" class=\"st0\" width=\"22\" height=\"16.2\" />\n\t\t<polygon class=\"st0\" points=\"35,20.5 35,27.5 40,30.5 40,17.5 \t\t\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol